import { LandingScene } from './scene';

export default function Landing() {
  return <LandingScene />;
}
